import { post } from '../../../../util/api'
import * as type from './type'
import { FILE_TYPE_CBCT_FILE } from '../const'
import { createChangeTableSettingAction } from '../../../form/state/table-state-helper'
import uploadByChunks from '../../util/cbct-file-upload-helper'

export const changeTableSetting = createChangeTableSettingAction(type.CHANGE_TABLE_SETTING)

export const uploadCustomerFileRequest = () => ({
    type: type.UPLOAD_CUSTOMER_FILE_REQUEST,
    payload: {},
})

export const uploadCustomerFileSuccess = () => ({
    type: type.UPLOAD_CUSTOMER_FILE_SUCCESS,
    payload: {},
})

export const uploadCustomerFileError = (error) => ({
    type: type.UPLOAD_CUSTOMER_FILE_ERROR,
    payload: {
        error,
    },
})

export const uploadCustomerFile = (fileList, customerId, fileType, onUploadSuccess) => (dispatch, getState) => {
    const state = getState()
    dispatch(uploadCustomerFileRequest())

    uploadByChunks(customerId, fileList, fileType, onUploadSuccess, state)
        .then((isNoError) => {
            if (isNoError) {
                dispatch(uploadCustomerFileSuccess())
            } else {
                dispatch(uploadCustomerFileError('Something went wrong'))
            }
        })
}

export const setDeleteFlagRequest = () => ({
    type: type.SET_DELETE_FLAG_REQUEST,
    payload: {},
})

export const setDeleteFlagSuccess = () => ({
    type: type.SET_DELETE_FLAG_SUCCESS,
    payload: {},
})

export const setDeleteFlagError = (error) => ({
    type: type.SET_DELETE_FLAG_ERROR,
    payload: {
        error,
    },
})

export const setDeleteFlag = (fileId, onDeleteFlagSuccess) => (dispatch, getState) => {
    dispatch(setDeleteFlagRequest())

    post('/api/file-system/set-delete-flag?fileId=' + fileId)
        .then(() => {
            dispatch(setDeleteFlagSuccess())
            onDeleteFlagSuccess(FILE_TYPE_CBCT_FILE, fileId)
        })
        .catch((error) => {
            dispatch(setDeleteFlagError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/cbct-file-upload/action.js